// ** React Imports
import { useState, createContext, useEffect } from "react";

// ** Intl Provider Import
import { IntlProvider } from "react-intl";

// ** Core Language Data
import messagesEn from "@src/assets/data/locales/en.json";
import messagesDe from "@src/assets/data/locales/de.json";
import messagesFr from "@src/assets/data/locales/fr.json";
import messagesPt from "@src/assets/data/locales/pt.json";
import messagesSa from "@src/assets/data/locales/sa.json";

// ** User Language Data
import userMessagesEn from "@src/assets/data/locales/en.json";
import userMessagesDe from "@src/assets/data/locales/de.json";
import userMessagesFr from "@src/assets/data/locales/fr.json";
import userMessagesPt from "@src/assets/data/locales/pt.json";
import userMessagesSa from "@src/assets/data/locales/sa.json";
import { useSelector } from "react-redux";

// ** Menu msg obj
const menuMessages = {
  en: { ...messagesEn, ...userMessagesEn },
  de: { ...messagesDe, ...userMessagesDe },
  fr: { ...messagesFr, ...userMessagesFr },
  pt: { ...messagesPt, ...userMessagesPt },
  sa: { ...messagesSa, ...userMessagesSa },
};

// ** Create Context
const Context = createContext();

const IntlProviderWrapper = ({ children }) => {
  const rtlState = useSelector((state) => state.layout.isRTL);
  const savedLocale = rtlState ? "sa" : "en";
  // ** States
  const [locale, setLocale] = useState(savedLocale);
  const [messages, setMessages] = useState(menuMessages[savedLocale]);
  const { translations } = useSelector((state) => state.layout);
  // ** Switches Language
  const switchLanguage = (lang) => {
    setLocale(lang);
    if (lang === "sa") {
      setMessages(translations);
    } else {
      setMessages(menuMessages[lang]);
    }
  };

  useEffect(() => {
    if (locale === "sa") {
      setMessages(translations);
    }
  }, [translations]);
  return (
    <Context.Provider value={{ locale, switchLanguage }}>
      <IntlProvider key={locale} locale={locale} messages={messages}>
        {children}
      </IntlProvider>
    </Context.Provider>
  );
};

export { IntlProviderWrapper, Context as IntlContext };
